import { render } from "./LabActivityView.vue?vue&type=template&id=0ee56de1&scoped=true"
import script from "./LabActivityView.vue?vue&type=script&lang=js"
export * from "./LabActivityView.vue?vue&type=script&lang=js"

import "./LabActivityView.vue?vue&type=style&index=0&id=0ee56de1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee56de1"]])

export default __exports__